import React from 'react';
import PublicOfferingStyles from './PublicOffering.module.scss';

const PublicOffering = () => {
        return (
            <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px', lineHeight: '1.6'}}>
                    <h1 className={PublicOfferingStyles.title}>ПУБЛИЧНАЯ ОФЕРТА</h1>
                    <p className={PublicOfferingStyles.subTitle}>О заключении договора розничной купли-продажи</p>
                    <br/>
                    <section>
                            <h3 style={{ fontWeight: 'bold', marginBottom: '12px' }}>1. Общие положения</h3>
                            <p>1.1. Интернет-магазин «эпатажность» (в лице самозанятого Чернецкого Владислава Станиславовича), расположенный на сайте <a href="https://epatazhnost.ru/" target="_blank" rel="noopener noreferrer">https://epatazhnost.ru/</a>, предлагает совершить покупку товаров на условиях, изложенных в настоящей оферте.</p>
                            <p>1.2. Заказ товара на сайте означает полное согласие Покупателя с условиями настоящего договора.</p>
                            <p>1.3. Настоящая оферта является официальным публичным предложением Продавца, адресованным неопределённому кругу лиц.</p>
                    </section>

                    <section>
                            <h3 style={{ fontWeight: 'bold', marginBottom: '12px' }}>2. Товары и цены</h3>
                            <p>2.1. Ассортимент, характеристики и цены товаров указаны на сайте.</p>
                            <p>2.2. Продавец оставляет за собой право изменять цены, ассортимент и условия акций без предварительного уведомления.</p>
                            <p>2.3. Окончательная стоимость товара определяется на момент оформления заказа.</p>
                    </section>

                    <section>
                            <h3 style={{ fontWeight: 'bold', marginBottom: '12px' }}>3. Порядок оформления и оплаты заказа</h3>
                            <p>3.1. Покупатель самостоятельно оформляет заказ через сайт или по согласованию с менеджером.</p>
                            <p>3.2. Оплата возможна:</p>
                            <ul>
                                    <li>онлайн (банковской картой, электронными платежами);</li>
                            </ul>
                            <p>3.3. После оплаты Покупатель получает подтверждение заказа на электронную почту или посредством Telegram.</p>
                    </section>

                    <section>
                            <h3 style={{ fontWeight: 'bold', marginBottom: '12px' }}>4. Доставка</h3>
                            <p>4.1. Способы и сроки доставки указаны на сайте.</p>
                            <p>4.2. Доставка может осуществляться курьерской службой или транспортной компанией.</p>
                            <p>4.3. Расходы на доставку оплачиваются Покупателем при оформлении заказа (стоимость доставки включается продавцом в стоимость), если иное не предусмотрено акциями магазина.</p>
                    </section>

                    <section>
                            <h3 style={{ fontWeight: 'bold', marginBottom: '12px' }}>5. Возврат и обмен</h3>
                            <p>5.1. Покупатель вправе вернуть или обменить товар надлежащего качества в течение 7 дней (согласно Закону о защите прав потребителей).</p>
                            <p>5.2. Товар ненадлежащего качества подлежит возврату/обмену в течение гарантийного срока.</p>
                    </section>

                    <section>
                            <h3 style={{ fontWeight: 'bold', marginBottom: '12px' }}>6. Конфиденциальность</h3>
                            <p>6.1. Персональные данные Покупателя обрабатываются в соответствии с Политикой конфиденциальности сайта.</p>
                    </section>

                    <section>
                            <h3 style={{ fontWeight: 'bold', marginBottom: '12px' }}>7. Контакты</h3>
                            <p>7.1. Продавец: Чернецкий Владислав Станиславович</p>
                            <p>7.2. Телефон: +7 964 702-83-10</p>
                            <p>7.3. Email: <a href="mailto:store@epatazhnost.world">store@epatazhnost.world</a></p>
                            <p>7.4. Адрес: Москва, Чертаново Северное, 5кА</p>
                    </section>

                    <p style={{ marginTop: '40px', fontStyle: 'italic', textAlign: 'center' }}>
                            Дата публикации оферты: 15 апреля 2025
                    </p>
            </div>
        );
};

export default PublicOffering;
